<script>

	import Fragment from '@/components/Fragment'
	import _ from 'lodash'
	import moment from 'moment'
	import localTimeZoneAbbrev from '@/utilities/localTimeZoneAbbrev'

	function timeOfTheDay (date) {
		return moment(date).format('h:mm A')
	}

	function dayOfTheWeek (date) {
		return moment(date).format('dddd')
	}

	function dateFormatted (date) {
		return moment(date).format('LL')
	}

	export default {
		name: "webinarTable",
		props: {
			webinars: Array
		},
		computed: {
			webinarsByDay () {
				const webinars = [...this.webinars].sort((a,b) => (new Date(a.startTime) - new Date(b.startTime)))
				return _.groupBy(webinars, (webinar) => (moment(webinar.startTime).format('YYYY-MM-DD')))
			},
			timeZoneAbbrev () {
				try {
					return new Date().toLocaleTimeString('en-us',{timeZoneName:'short'}).split(' ')[2]
				} catch (e) {
					return null
				}
			}
		},
		render () {
			return (
				<div class="webinar-table">
					{Object.entries(this.webinarsByDay).map(([date, webinars]) => (
						<Fragment key={date}>
							<h2 id={date}>
								<container>
									<div class="webinar-table__header">
										<span class="day">{dayOfTheWeek(date)}</span>
										<span class="date">{dateFormatted(date)}</span>
									</div>
								</container>
							</h2>
							<div class="list-wrap">
								<container>
									<ol>
										{webinars.map((webinar) => (
											<li class="webinar-table__detail" key={webinar.id}>
												<time id={`${webinar.id}-time`} class="time">
													{timeOfTheDay(webinar.startTime)} - {timeOfTheDay(webinar.endTime)} {localTimeZoneAbbrev()}
												</time>
												<span id={`${webinar.id}-desc`} class="description">
													{webinar.title}
												</span>
												<btn class="small">
													<router-link to={{ name: 'webinarsRegister', params: { webinarId: webinar.id } }} class="cta" aria-describedby={`${webinar.id}-desc ${webinar.id}-time ${date}`}>
														Register Now
													</router-link>
												</btn>
											</li>
										))}
									</ol>
								</container>
							</div>
						</Fragment>
					))}
				</div>
			)
		}
	}

</script>

<style lang="scss" scoped>

	@import "media";

	.webinar-table	{
		color:#6D6E71;
		h2 {
			background:#EFF3F4; font-family:"proxima-nova", sans-serif; font-weight:300;
		}
		.list-wrap {
			margin:0; background:#F8FAFA;
		}
		ol {
			margin:0; padding:0; list-style-type:none;
		}
		&__header {
			display:flex; align-items:center; justify-content:space-between;
		}
		&__detail {
			padding:1rem 0;
			@include media(large) {
				display:flex; align-items:center; justify-content:space-between; white-space:nowrap;
			}
			@include media(small, large) {
				// flex-wrap:wrap; margin-bottom:1rem;
				> * {
					display:block;
				}
				> * + * {
					margin:1rem 0;
				}
			}
		}
		.day, .date {
			font-size:2rem; line-height:3; font-weight:600;
		}
		.time {
			font-size:1.6rem; white-space:nowrap;
		}
		.description {
			font-size:2.1rem;
			@include media(small, large) {
				font-size:2rem; line-height:1.3; font-weight:500;
			}
			@include media(large) {
				padding:0 1rem; overflow:hidden; text-overflow:ellipsis;
			}
		}
		.small {
			@include media(small, large) {
				flex-basis:100%;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/Webinar/WebinarTable.vue